import { convertIfPDF } from '@jane/shared/util';

import { AllowedFiletypes } from './allowedFileTypes';

export type ProcessedFile = {
  data: File;
  name: string;
  source: string;
  type: string;
};

type ProcessPdfArgs = {
  file: File;
  setError: (error: string) => void;
};

export const processPdf = (
  { file, setError }: ProcessPdfArgs,
  processedCallback: (fileInfo: ProcessedFile) => void
) => {
  const filename = `${file.name.split('.').slice(0, -1).join('.')}.jpeg`;
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    convertIfPDF(reader.result as string).then(
      (result) => {
        fetch(result)
          .then((res) => res.blob())
          .then((blob) => {
            const convertedFile = new File([blob], filename, {
              type: AllowedFiletypes.JPEG,
            });
            processedCallback({
              source: 'file input',
              name: filename,
              type: convertedFile.type,
              data: convertedFile,
            });
          });
      },
      (_err) => {
        setError(
          'Unable to convert PDF file. Please choose a different image.'
        );
      }
    );
  };
};
